import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiClient } from '@app/core/services/base-api-client.service';
import { LoadingIndicatorService } from '@app/core/services/loading-indicator.service';
import { LogService } from '@app/core/services/log.service';
import { Environment } from '@env/environment';
import { KpaReturnResult } from '@app/core/models/kpa-return-result';
import { Observable, catchError, tap } from 'rxjs';
import { UpcomingTask } from '../models/upcoming-tasks';
import { CompletedTask } from '../models/completed-tasks';

const httpOptions = {
	headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
export interface ITrainingService {
	url: string;
	record(scheduleId: number): Observable<boolean>;
}
@Injectable({
	providedIn: 'root',
})
export class TrainingService extends BaseApiClient implements ITrainingService {
	/**
	 * The base URL for the API domain.
	 */
	public baseUrl: string;

	/**
	 * The URL to the API endpoint.
	 */
	public url: string;

	constructor(
		private readonly http: HttpClient,
		private readonly log: LogService,
		private readonly loadingIndicatorService: LoadingIndicatorService,
		environment: Environment
	) {
		super();
		this.baseUrl = environment.services['employee'];
		this.url = this.baseUrl + 'training';
	}

	/**
	 * Record Training
	 */
	record(scheduledId: number): Observable<boolean> {
		const url = `${this.url}/Record?scheduledId=${scheduledId}`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.post<boolean>(url, null, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
}
